import React from 'react';
import { Form, Input, Upload, Typography } from 'antd';
import { useShortTextValidationRules } from '@validation/shortText';
import { useRequiredValidationRules } from '@validation/required';
import { PortableTextInput } from '@components/input/PortableTextInput';
import useTranslation from 'next-translate/useTranslation';
import { pageUrl } from '@utils/url';
import { AppPages } from '@constants/app';
import { UploadChangeParam } from 'antd/lib/upload';
import { UploadFile } from 'antd/lib/upload/interface';
import { UploadFileResponse } from '@typings/UploadFileResponse';
import { TPortableText } from '@typings/TPortableText';
const { Text } = Typography;

export type FormValues = {
  title: string;
  message: TPortableText;
  files?: UploadFile<UploadFileResponse>[];
}

type Props = {
  onSubmit: (values: FormValues) => Promise<void>;
}

export const ReportErrorModalForm: React.FC<Props> = ({ onSubmit }) => {
  const { t } = useTranslation('global');
  const [form] = Form.useForm<FormValues>();

  const titleValidationRules = React.useRef(useShortTextValidationRules({
    name: t('report-error-modal.form.fields.title'),
    required: true,
  }));

  const messageValidationRules = React.useRef(useRequiredValidationRules({
    name: t('report-error-modal.form.fields.message'),
  }));

  const normalizeValueFromEvent = React.useCallback((payload: UploadChangeParam<UploadFile<UploadFileResponse>>) => {
    return payload.fileList;
  }, []);

  return (
    <Form id="report-error" layout="vertical" form={form} onFinish={onSubmit}>
      <Form.Item required name="title" rules={titleValidationRules.current} label={t('report-error-modal.form.fields.title')}>
        <Input />
      </Form.Item>
      <Form.Item required name="message" rules={messageValidationRules.current} label={t('report-error-modal.form.fields.message')}>
        <PortableTextInput />
      </Form.Item>
      <Form.Item label={t('report-error-modal.form.fields.files.label')}>
        <Form.Item name="files" valuePropName="fileList" getValueFromEvent={normalizeValueFromEvent}>
          <Upload.Dragger multiple name="files" action={pageUrl.relative(AppPages.API.ASSETS.FILE.UPLOAD.FROM_FILE)}>
            <Text>{t('report-error-modal.form.fields.files.message')}</Text>
          </Upload.Dragger>
        </Form.Item>
      </Form.Item>
    </Form>
  );
}